import { getCountIriStr } from "components/Form/components/Autocomplete/Autocomplete.selectors";
import isEqual from "lodash/isEqual";
import unionWith from "lodash/unionWith";

export const actions = {
    START_FETCHING_AUTOCOMPLETE: "START_FETCHING_AUTOCOMPLETE",
    FETCH_AUTOCOMPLETE_SUCCESSFUL: "FETCH_AUTOCOMPLETE_SUCCESSFUL",
    FETCH_AUTOCOMPLETE_FAILED: "FETCH_AUTOCOMPLETE_FAILED",

    STORE_AUTOCOMPLETE_DATA: "STORE_AUTOCOMPLETE_DATA",
    STORE_AUTOCOMPLETE_COUNT: "STORE_AUTOCOMPLETE_COUNT",
    STORE_SEARCH_RESULTS: "STORE_SEARCH_RESULTS",
    CLEAR_SEARCH_RESULTS: "CLEAR_SEARCH_RESULTS",
    STORE_SEARCH_COUNT: "STORE_SEARCH_COUNT",
};

export const initialState = {
    singleFetching: [],
    listingResponse: {},
    listingFetching: false,
    searchResults: {}, // { [iri]: { results: [], count: number } }
};

export default (state = initialState, { type, response, iri, overwritePrevValue }) => {
    switch (type) {
        case actions.START_FETCHING_AUTOCOMPLETE: {
            return {
                ...state,
                singleFetching: {},
                listingFetching: true,
            };
        }
        case actions.FETCH_AUTOCOMPLETE_SUCCESSFUL: {
            return {
                ...state,
                listingFetching: false,
            };
        }
        case actions.FETCH_AUTOCOMPLETE_FAILED: {
            return {
                ...state,
                listingFetching: false,
            };
        }
        case actions.STORE_AUTOCOMPLETE_DATA: {
            const existing = state[iri];
            return Object.assign({}, state, {
                [iri]: overwritePrevValue ? response : unionWith(existing, response, isEqual),
            });
        }
        case actions.STORE_AUTOCOMPLETE_COUNT: {
            return Object.assign({}, state, {
                [getCountIriStr(iri)]: response,
            });
        }
        case actions.STORE_SEARCH_RESULTS: {
            const existingSearchResults = state.searchResults[iri]?.results || [];
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    [iri]: {
                        ...state.searchResults[iri],
                        results: overwritePrevValue
                            ? response
                            : unionWith(existingSearchResults, response, isEqual),
                    },
                },
            };
        }
        case actions.STORE_SEARCH_COUNT: {
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    [iri]: {
                        ...state.searchResults[iri],
                        count: response,
                    },
                },
            };
        }
        case actions.CLEAR_SEARCH_RESULTS: {
            return {
                ...state,
                searchResults: {
                    ...state.searchResults,
                    [iri]: {
                        results: [],
                        count: 0,
                    },
                },
            };
        }
        default:
            return state;
    }
};
